"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.InteractiveStreamPropTypes = exports.InteractiveStreamListPropTypes = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var InteractiveStreamPropTypes = exports.InteractiveStreamPropTypes = _propTypes["default"].shape({
  _id: _propTypes["default"].string.isRequired,
  featuredImage: _propTypes["default"].string,
  title: _propTypes["default"].string,
  endOn: _propTypes["default"].number,
  startOn: _propTypes["default"].number,
  description: _propTypes["default"].string,
  shortId: _propTypes["default"].string
});
var InteractiveStreamListPropTypes = exports.InteractiveStreamListPropTypes = _propTypes["default"].arrayOf(_propTypes["default"].shape({
  _id: _propTypes["default"].string.isRequired,
  theme: _propTypes["default"].shape({
    featuredImage: _propTypes["default"].string
  }),
  title: _propTypes["default"].string,
  endOn: _propTypes["default"].number,
  startOn: _propTypes["default"].number,
  description: _propTypes["default"].string,
  shortId: _propTypes["default"].string
}));